import React from 'react'

import { Box, CircularProgress, Grid, Loader, RoundedPlainTextButton } from '@percept/mui'

import { Add } from '@percept/mui/icons'

import { Webinar } from './Webinar'

import { MediaAcademyWebinarsHookProps, useMediaAcademyWebinars } from './hooks'

import { flatMap } from 'lodash-es'


export type WebinarListingProps = Pick<
  MediaAcademyWebinarsHookProps,
  'order' | 'start' | 'end' | 'category'
> & {
  descriptor?: string
}


export const WebinarListing = ({
  order,
  start,
  end,
  category,
  descriptor,
}: WebinarListingProps): JSX.Element => {

  const {
    isLoading,
    isError,
    data,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetch,
  } = useMediaAcademyWebinars({
    order,
    start,
    end,
    category,
    limit: 10,
  })

  const webinars = data && data.pages && flatMap(data.pages, d => d.items )

  const emptyMessage = (
    descriptor ?
      `No ${descriptor} webinars found` :
      'No webinars found'
  )

  return (
    <Box>
      { isLoading && <Loader preset='centered' minHeight='50vh' /> }
      { webinars && (
        !webinars.length ? (
          <Box p={8} display='flex' justifyContent='center' fontSize={22} color='text.secondary'>
            { emptyMessage }
          </Box>
        ) : (
          <Grid container spacing={4}>
            { webinars.map( webinar => (
              <Grid
                key={webinar.id}
                item
                xs={12}
                md={6}
                lg={4}
                xl={3}>
                <Webinar {...webinar} />
              </Grid>
            ))}
          </Grid>
        )
      )}
      { hasNextPage && (
        <Box mt={6} display='flex' justifyContent='center'>
          <RoundedPlainTextButton
            color='primary'
            variant='contained'
            size='large'
            disabled={isFetchingNextPage}
            startIcon={
              isFetchingNextPage ?
                <CircularProgress size='1em' color='inherit' /> :
                <Add />
            }
            onClick={(): void => {
              fetchNextPage()
            }}>
            Load More
          </RoundedPlainTextButton>
        </Box>
      )}
    </Box>
  )
}
